
import { PERMISSIONS_CONFIG } from '../config/permissionsConfig';

/**
 * Utilities for managing refresh cooldown periods
 */
export const cooldownUtils = {
  /**
   * Check if enough time has passed since last refresh
   */
  isInCooldown: (lastRefreshed: number, recentlyInvalidated: boolean): boolean => {
    if (recentlyInvalidated) {
      return false; // Skip cooldown if recently invalidated
    }
    
    const now = Date.now();
    return now - lastRefreshed < PERMISSIONS_CONFIG.COOLDOWN_PERIOD;
  },

  /**
   * Log cooldown skip message
   */
  logCooldownSkip: (): void => {

  },
};
